// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalDivider_wrapper__PNigP"};